import { useEffect, useState } from "react";
import EditableTable from "../../Reusable/Table/EditableTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Tag,
  message,
  Input,
  Button,
  Form,
  Select,
  Modal,
  Popconfirm,
} from "antd";
import consts from "../../constant";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import Loadingpage from "../Loadingpage/Loadingpage";

const Rolemanage = () => {
  useEffect(() => {
    // Inject styles for the select dropdown to ensure readability and neon theme
    const style = document.createElement("style");
    style.innerHTML = `
      .role-select-dropdown {
        background: linear-gradient(180deg, rgba(252, 68, 32, 0.2) 0%, rgba(252, 68, 32, 0.04) 100%);
        backdrop-filter: blur(10px) !important;
        border: 1px solid FC442033!important;
      }
      .role-select-dropdown .ant-select-item-option {
        color: rgb(255, 255, 255) !important;
        transition: all 0.2s ease !important;
      }
      .role-select-dropdown .ant-select-item-option-active {
        color: #fff !important;
        background-color: var(--secondary-color) !important;
      }
      .role-select-dropdown .ant-select-item-option-selected {
        color: #fff !important;
        background-color: var(--secondary-color) !important;
      }
      .role-select-dropdown .ant-select-item-option-disabled {
        color: rgba(255, 255, 255, 0.5) !important;
        cursor: not-allowed !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("false");
  const [messageApi, contextHolder] = message.useMessage();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pairStatus, setPairStatus] = useState(null);
  const [status, setStatus] = useState("active");
  const [searchText, setSearchText] = useState("");
  const [searchTrigger, setSearchTrigger] = useState("");
    const [selectedAssets, setSelectedAssets] = useState(null);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const { Search } = Input;



  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
    setOpenViewDrawer(false);
  };

  const [roleUser, setRoleUser] = useState([]);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/get-roles`,
        { status: pairStatus === 'active' ? true : pairStatus === 'inactive' ? false : undefined },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response.data.success) {
        let data = response.data.result.map((item, index) => ({
          ...item,
          key: item._id,
          sno: index + 1,
          rolename: item.name,
          permission: item.permissions.join(", "),
          status: item.status === false ? "inactive" : "active", // Map boolean to string
        }));

        // Apply search locally since getRoles API doesn't support search text natively right now
        if (searchTrigger) {
          data = data.filter(d => (d.rolename || '').toLowerCase().includes(searchText.toLowerCase()));
        }

        setRoleUser(data);
        setTotal(data.length);
      } else {
        messageApi.open({ type: "error", content: response.data.message });
      }
    } catch (error) {
      console.error("Fetch Roles Error:", error);
      messageApi.open({ type: "error", content: "Failed to fetch roles" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [searchTrigger, pairStatus, page.current, page.pageSize]);
  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },

    {
      title: " Role name",
      dataIndex: "rolename",
      key: "rolename",
      searchable: true,
    },
    // { title: "Permission", dataIndex: "permission", key: "permission" },
    {
      title: "Permission",
      dataIndex: "permission",
      key: "permission",
      render: (value) => {
        const permissions = value ? value.split(", ") : [];
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
            {permissions.map((p) => (
              <Tag
                key={p}
                style={{
                  background: "rgba(46, 255, 12, 0.15)",
                  border: "1px solid #ffffffff",
                  color: "#f4f4f4ff",
                  margin: 0,
                  borderRadius: "6px",
                  fontWeight: 900,
                }}
              >
                {p}
              </Tag>
            ))}
          </div>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        return value === "active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">In-Active</Tag>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value) => new Date(value).toLocaleDateString(),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEditAsset(record)}
          style={{ color: "#2eff0c" }}
        >
          Edit
        </Button>
      ),
    },
  ];

  // Edit
  const handleEditAsset = (record) => {
    setSelectedAssets(record);
    setIsFormChanged(false);
    setIsModalOpen(true);

    form.setFieldsValue({
      rolename: record.rolename,
      permission: record.permission ? record.permission.split(", ") : [],
      status: record.status,
    });
  };

  // multi select
  const sidebarItems = [
    { label: "Dashboard", value: "Dashboard" },
    { label: "Users", value: "Users" },
    { label: "Users wallet", value: "Users wallet" },
    { label: "KYC Management", value: "KYC Management" },
    // { label: "Crypto History", value: "Crypto History" },
    { label: "Binary Trade", value: "HighLow" },
    // { label: "UpDown", value: "UpDown" },
    // { label: "HighLow Spread", value: "HighLow Spread" },
    // { label: "TapTrade", value: "TapTrade" },
    // { label: "Spin And Win", value: "Spin And Win" },
    { label: "Trade Settings", value: "Trade Settings" },
    { label: "Payment Settings", value: "Payment Settings" },
    { label: "Deposit", value: "Deposit" },
    { label: "Withdraw", value: "Withdraw" },
    { label: "Pairs", value: "Pairs" },
    { label: "Supports", value: "Supports" },
    // { label: "Sub Admin", value: "Sub Admin" },
    { label: "Under Maintenance", value: "Under Maintenance" },
    { label: "Announcements", value: "Announcements" },
    { label: "Settings", value: "Settings", disabled: true },
  ];

  const showModal = () => {
    setLoading(true);

    setTimeout(() => {
      form.resetFields();
      form.setFieldsValue({ permission: ["Settings"], status: "active" });
      setSelectedAssets(null);
      setIsFormChanged(true);
      setIsModalOpen(true);
      setStatus("active");
      setLoading(false);
    }, 2000);
  };

  const handleDelete = async () => {
    if (!selectedAssets) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${consts.BackendUrl}/delete-role`,
        { id: selectedAssets._id },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response.data.success) {
        messageApi.open({ type: "success", content: "Role deleted successfully!" });
        setIsModalOpen(false);
        fetchRoles();
      } else {
        messageApi.open({ type: "error", content: response.data.message });
      }
    } catch (error) {
      console.error("Delete Role Error:", error);
      messageApi.open({ type: "error", content: error.response?.data?.message || "Failed to delete role" });
    } finally {
      setLoading(false);
    }
  };


  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handlePagination = (pagination) => {
    console.log("Table params:", pagination);
    setPage(pagination);
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        name: values.rolename,
        permissions: values.permission,
        status: values.status === "active" ? true : false,
      };

      if (selectedAssets) {
        payload.id = selectedAssets._id;

        // Validate identical changes
        const existingPermissions = selectedAssets.permission ? selectedAssets.permission.split(", ") : [];
        const isIdentical =
          selectedAssets.rolename === values.rolename &&
          JSON.stringify(existingPermissions.sort()) === JSON.stringify([...values.permission].sort()) &&
          selectedAssets.status === values.status;

        if (isIdentical) {
          messageApi.open({ type: "warning", content: "No changes detected" });
          setLoading(false);
          return;
        }
      }

      const response = await axios.post(
        `${consts.BackendUrl}/create-roles`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (response.data.success) {
        messageApi.open({
          type: "success",
          content: selectedAssets ? "Role updated successfully!" : "Role created successfully!"
        });
        setIsModalOpen(false);
        setSelectedAssets(null);
        form.resetFields();
        fetchRoles();
      } else {
        messageApi.open({ type: "error", content: response.data.message });
      }

    } catch (error) {
      console.error("Submit Role Error:", error);
      messageApi.open({ type: "error", content: error?.response?.data?.message || "Failed to submit role" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="display-2 p-10">
        <h2>Role Management</h2>
        <div className="display-2  ">
          <Search
            placeholder="Search for name"
            value={searchText}
            onChange={(e) => {
              const value = e.target.value;

              setSearchText(value);

              // clear icon click
              if (!value) {
                setSearchTrigger("");

                setPage({
                  current: 1,
                  pageSize: 10,
                });
              }
            }}
            onSearch={(value) => {
              setPage((prev) => ({
                ...prev,
                current: 1,
              }));

              setSearchTrigger(value);
            }}
            allowClear
            style={{ width: 200 }}
            loading={confirmLoading}
            className="input-cls"
          />

          <Select
            allowClear
            placeholder=" Status"
            value={pairStatus}
            style={{ width: 130, marginLeft: 10 }}
            onChange={(e) => {
              setPairStatus(e);
              setPage({ current: 1, pageSize: 10 });
            }}
          >
            <Select.Option value={"active"}>Active</Select.Option>
            <Select.Option value={"inactive"}>In Active</Select.Option>
          </Select>

          <Button
            onClick={() => {
              setSearchText("");
              setSearchTrigger("");
              setPairStatus(null);
              setPage({ current: 1, pageSize: 10 });
            }}
            style={{ marginLeft: 10 }}
          >
            Clear Filter
          </Button>

          <Button
            onClick={showModal}
            style={{ marginLeft: 10 }}
            icon={<PlusCircleOutlined />}
            loading={loading}
          >
            Create role
          </Button>
        </div>
      </div>
      <EditableTable
        columnsConfig={userColumns}
        dataSource={roleUser}
        className="mt-20"
        total={total}
        pageSize={10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
        loading={confirmLoading}
      />
      <Loadingpage isLoading={loading} />
      <div>
        <Modal
          title={selectedAssets ? "Edit Role" : "Create Role"}
          open={isModalOpen}
          footer={null}
          // className="roleuser-modal  "
          centered
          onCancel={handleCancel}
          maskClosable={false}
          maskStyle={{
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          }}
          styles={{
            content: {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              color: "white",
            },
            header: {
              backgroundColor: "transparent",
            },
          }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onValuesChange={(changedValues, allValues) => {
              if (changedValues.permission) {
                if (!changedValues.permission.includes("Settings")) {
                  const newPermissions = [...changedValues.permission, "Settings"];
                  form.setFieldsValue({ permission: newPermissions });
                  allValues.permission = newPermissions;
                }
              }

              if (!selectedAssets) {
                setIsFormChanged(true);
                return;
              }
              const existingPermissions = selectedAssets.permission
                ? selectedAssets.permission.split(", ")
                : [];
              const isIdentical =
                selectedAssets.rolename === allValues.rolename &&
                JSON.stringify(existingPermissions.sort()) ===
                JSON.stringify([...(allValues.permission || [])].sort()) &&
                selectedAssets.status === allValues.status;

              setIsFormChanged(!isIdentical);
            }}
          >
            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: "Please select status" }]}
            >
              <Select placeholder="Select status">
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="inactive">Inactive</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Role Name"
              name="rolename"
              rules={[
                { required: true, message: "Please enter role name" },
                { min: 3, message: "Minimum 3 characters" },
                {
                  pattern: /^[a-zA-Z0-9]+$/,
                  message: "Only letters and numbers are allowed",
                },
              ]}
            >
              <Input
                maxLength={50}
                placeholder="Enter role name"
                style={{ background: "transparent" }}
                autoComplete="off"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  form.setFieldsValue({ rolename: value });
                }}
              />
            </Form.Item>

            <Form.Item
              label="Roles"
              name="permission"
              rules={[{ required: true, message: "Please select roles" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select roles"
                options={sidebarItems}
                popupClassName="role-select-dropdown"
              />
            </Form.Item>
            <div className="display-2">
              <Form.Item>
                <Button
                  htmlType="submit"
                  loading={loading}
                  disabled={selectedAssets && !isFormChanged}
                >
                  {selectedAssets ? "Edit" : "Create"}
                </Button>
              </Form.Item>

              {selectedAssets && (
                <Form.Item>
                  <Popconfirm
                    title={
                      <span style={{ color: "white" }}>Delete the role</span>
                    }
                    description={
                      <span style={{ color: "white" }}>
                        Are you sure you want to delete this role?
                      </span>
                    }
                    onConfirm={handleDelete}
                    okText="Yes"
                    cancelText="No"
                    overlayInnerStyle={{
                      backgroundColor: "#FC442033",
                      border: "1px solid #FC442080",
                    }}
                  >
                    <Button
                      type="primary"
                      htmlType="button"
                      loading={loading}
                      danger
                      className="delete-btn"
                    >
                      Delete
                    </Button>
                  </Popconfirm>
                </Form.Item>
              )}
            </div>
          </Form>
        </Modal>
      </div>
      {contextHolder}
    </>
  );
};;

export default Rolemanage;
